var app = angular.module("leonardo");

var VendorList = function($scope, VendorService, FilterService, ngDialog, PermissionService, $timeout) {
  $scope.vendors = [];
  $scope.vendorsGrouped = [];
  $scope.permissionService = PermissionService;

  $scope.categoryExpanded = null;

  $scope.showVendorDeleteDialog = function(vendor) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: vendor,
        type: 'vendor'
      }
    }).then(function(data){
      VendorService.updateCollection(data, true);
      $scope.refresh();
    }, function () {
      return;
    });
  };

  $scope.showEmailDialog = function(vendor) {
    ngDialog.open({
      template: 'views/templates/dialog/vendor/email.html',
      controller: 'EmailVendorDialog',
      data: {
        vendor: vendor
      }
    });
  };

  $scope.toggleCategory = function(category) {
    $scope.categoryExpanded = ($scope.categoryExpanded == category) ? null : category;
  };

  $scope.categoryIsExpanded = function(category) {
    return $scope.categoryExpanded == category;
  };

  $scope.getParams = function() {
    var filters = {disable_pagination: true};
    if (FilterService.hasFilter('account_reports')) {
      filters['account'] = FilterService.getFilter('account_reports');
    }
    if (FilterService.hasFilter('vendor_name')) {
      filters['name'] = FilterService.getFilter('vendor_name');
    }
    return filters;
  };

  $scope.groupVendors = function() {
    var vendorsGrouped = {}, categories = [], category_ids = [];
    $scope.vendorsGrouped = [];
    angular.forEach($scope.vendors, function(vendor) {
      if (!_.contains(category_ids, vendor.category.id)) {
        vendorsGrouped[vendor.category.id] = [];
        categories.push(vendor.category);
        category_ids.push(vendor.category.id);
      }
      vendorsGrouped[vendor.category.id].push(vendor);
    });
    angular.forEach(categories, function(category) {
      $scope.vendorsGrouped.push({
        category: category,
        vendors: vendorsGrouped[category.id]
      });
    });
    if (categories.length === 1) {
      $scope.categoryExpanded = categories[0];
    }
  };

  $scope.refresh = function() {
    VendorService.getlist($scope.getParams()).then(function(data) {
      $scope.vendors = data;
      $scope.groupVendors();
    });
  };

  $scope.$on('vendor:added', $scope.refresh);

  $scope.$on('filter-selection:updated', $scope.refresh);

  $timeout(function () {
    $scope.refresh();
  }, 0);
};

app.controller('VendorList', ['$scope', 'VendorService', 'FilterService', 'ngDialog', 'PermissionService', '$timeout', VendorList]);
